// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { nullOrUndefined, string, boolean, number } from "@altostra/type-validations/lib/primitives";

export const isGetEmailSettingsResponse = objectOf({
  ip_pools: arrayOf(nullOrUndefined),
  default_from_email_address: string,
  default_from_email_display_name: string,
  default_reply_to_address: nullOrUndefined,
  disable_custom_email: boolean,
  default_should_inline_css: boolean,
  default_override_email_open_tracking_pixel_to_top: objectOf({
    "0": boolean,
    "3": boolean,
  }),
  web_push_url: string,
  default_from_emails: arrayOf(
    objectOf({
      display_name: string,
      address: string,
    })
  ),
  default_reply_to_emails: arrayOf(
    objectOf({
      display_name: nullOrUndefined,
      address: string,
    })
  ),
  from_email_addresses: arrayOf(
    objectOf({
      address: string,
      display_name: string,
      ip_pool_name: string,
      ip_pool_id: string,
      esp: number,
      default: boolean,
    })
  ),
  app_group_esps: arrayOf(number),
  bcc_email_addresses: arrayOf(string),
  bcc_email_addresses_default_idx: nullOrUndefined,
  bcc_email_address_required: boolean,
  use_customized_list_unsubscribe_header: boolean,
  list_unsubscribe_one_click_url: string,
  list_unsubscribe_mailto_url: string,
});
